<template>
  <div>
    <vs-collapse class="import-collapse p-0">
      <vs-collapse-item>
      <!-- <pre>{{assignmentDataList.assignment}}</pre> -->
        <div slot="header">
          <h4
            style="padding: 10px; margin: 5px auto; display: inline-block"
            class="text-center"
          >
            <!-- {{editingtrue}} -->
            <span v-if="editingtrue"> Assignment Added </span>
            <span v-else>Imported Assignment</span>
          </h4>

          <vs-tooltip
          class="mr-10"
          style="margin:5px;float: right;"
          text="Remove all imported assignments" 
          position="top"
          color="rgb(234, 84, 85)"
          >
          <vs-button
            class="mb-2"
            color="danger" type="filled" icon-pack="feather" icon="icon-trash"
            @click="removeImportedQuestions"
          >
          </vs-button>
          </vs-tooltip>
        </div>
        <vs-divider />

        <!-- <pre>{{assignmentDataList}}</pre>  -->

        <vs-card
          style="padding: 10px"
          v-for="(assignmentDataList, index) in assignmentDataList"
          :key="index"
        >

        <vs-tooltip
            text="Remove this imported assignment" 
            position="top"
            color="danger"
            style="margin:5px;float: right;"
            >
          <vs-button
            class="mb-2"
            color="danger"
            type="filled"
            icon="remove"
            @click="removeIndividualAssignment(index)"
          >
          </vs-button>
        </vs-tooltip>
          <vs-divider />

          <vs-row>
            <vs-col vs-w="12">
              <h5>Title : {{ assignmentDataList.assignment.title }}</h5>
              <vs-divider />
            </vs-col>
            <vs-col vs-w="12">
              <h5>Description : {{ assignmentDataList.assignment.description }}</h5>
              <vs-divider />
            </vs-col>
            <vs-col vs-w="12">
              <h5>
                Type : {{ assignmentDataList.assignment.assignment_type_obj.name }}
              </h5>
              <vs-divider />
            </vs-col>
            <vs-col vs-w="12">
              <h5>
                Subjects : {{ assignmentDataList.assignment.subject.subject_name }}
              </h5>
              <vs-divider />
            </vs-col>
          </vs-row>
      
          <vs-card
            style="padding: 10px"
            v-for="(questions, index) in assignmentDataList.assignment.questions"
            :key="index"
          >
            <div class="question_info">
              <h5>{{ index + 1 }}. {{ questions.title }}</h5>

              <vs-divider />
              <p>
                <b>Question Type : </b>{{ questions.question_input_type.label }}
              </p>

              <vs-divider />
              <p><b>Points : </b>{{ questions.point }}</p>

              <div class="" v-if="questions.questions_options.length > 0">
                <vs-divider />
                <p><b>Options :</b></p>
                <ul>
                  <li
                    class="question_options"
                    v-for="(options, index) in questions.questions_options"
                    :key="index"
                  >
                    <p>
                      {{ index + 1 }}. {{ options.option_name
                      }}<span v-if="options.is_answer == true">
                        - <b><i>Correct Answer</i></b></span
                      >
                    </p>
                  </li>
                </ul>
              </div>

              <div
                class=""
                v-if="questions.answer != '' && questions.answer !== null"
              >
                <vs-divider />
                <p><b>Answer : </b> {{ questions.answer }}</p>
              </div>

              <vs-divider />
              <p><b>Feedback : </b> {{ questions.feedback }}</p>

              <vs-divider />
              <p><b>Links : </b> 
              <!-- {{questions.links}} -->
              </p>
              
              <!-- Links Preview Component Start -->
              <LinkPreviewComponent
              :question_detail="questions"
              type="Import">
              </LinkPreviewComponent>
              <!-- Links Preview Component End -->

              <!-- Attatched Files Preview Start -->
              <vs-row v-if="questions.files.length > 0">
                <vs-divider />
                <vs-col>
                  <div class="">
                    <h5><b>Attached files</b></h5>
                    <br />
                    <div
                      class=""
                      v-for="(files, index) in questions.files"
                      :key="index"
                    >
                      <b
                        ><h5>File {{ index + 1 }}</h5></b
                      ><br />
                      <div v-if="files.file !== null">
                        <div class="" v-if="files.file.file_type.includes('image')">
                          <p>File Name : {{ files.file.file_name }}</p>
                          <p>File Type : {{ files.file.file_type }}</p>
                          <br />
                          <img
                            class="fileUpload-image"
                            :src="files.file.file_path"
                          />

                          <vs-divider />
                        </div>

                        <div class="" v-if="files.file.file_type.includes('video')">
                          <p>File Name : {{ files.file.file_name }}</p>
                          <p>File Type : {{ files.file.file_type }}</p>

                          <video width="320" height="240" controls>
                            <source :src="files.file.file_path" type="video/mp4" />
                            <source :src="files.file.file_path" type="video/ogg" />
                            Your browser does not support the video tag.
                          </video>
                          <vs-divider />
                        </div>

                        <div class="" v-if="files.file.file_type.includes('audio')">
                          <p>File Name : {{ files.file.file_name }}</p>
                          <p>File Type : {{ files.file.file_type }}</p>
                          <br />
                          <audio controls>
                            <source :src="files.file.file_path" type="audio/ogg" />
                            <source :src="files.file.file_path" type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                          <vs-divider />
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
            </div>
          </vs-card>
        </vs-card>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>
<script>
import LinkPreviewComponent from '@/components/LinkPreview/LinkPreviewComponent'
export default {
  props: {
    assignmentDataList: {
      type: Array
    },
    editingtrue: {
      type: Boolean,
      default: false
    },
    lesson_file_index: {
      default: null
    }
  },
  components: {
    LinkPreviewComponent
  },
  data () {
    return {}
  },
  methods: {
    removeImportedQuestions () {
      const allAssignment = {
        lesson_file_index: this.lesson_file_index,
        type: 'allDelete'
      }
      this.$emit('removeImportedAssignmentEvent', allAssignment)
    },

    removeIndividualAssignment (index) {
      // 
      const SingleAssignment = {
        removeIndex: index,
        lesson_file_index: this.lesson_file_index,
        type: 'single'
      }
      this.$emit('removeImportedAssignmentEvent', SingleAssignment)
    }
  }
}
</script>